<template>
  <div class="overlay" @click.stop="closeMenu()">
    <div class="menu" @click.stop="">
      <div class="menu__title">{{ $t('helpMenu.HELP') }}</div>
      <div class="menu__actions">
        <span @click.stop="openHelpModal()"><i class="material-icons">mail</i>{{ $t('helpMenu.CONTACT_US') }}</span>
        <span @click.stop="openOnboardingModal()" v-if="!(user.role?.toLowerCase() === 'learninguser' && user.type?.toLowerCase() === 'joven')"><i class="material-icons">visibility</i>{{ $t('helpMenu.VIEW_TUTORIAL') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';


export default {
  setup(_, { emit }) {

    const store = useStore();
    const user = computed(() => store.getters.manageUser_user);


    function closeMenu() {
      emit("closeHelpMenu");
    }

    function openHelpModal(){
      emit('openHelpModal');
    }

    function openOnboardingModal(){
      emit('openOnboardingModal');
    }

    return {
      closeMenu,
      openHelpModal,
      openOnboardingModal,
      user,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.overlay {
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2500;
  background-color: transparent;
  .menu {
    position: fixed;
    width: fit-content;
    height: 188px;
    top: 55px;
    right: 70px;
    margin: 0 6px 0 0;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    border-radius: 0;
    background-color: #fff;
    box-shadow: -2px 3px 3px 0px rgba(0, 0, 0, 0.1);
    z-index: 20;
    @media screen and (max-width: 1000px){
      top: 46px;
      right: 90px;

    }
    &__title {
      padding: 20px 0;
      border-bottom: 1px solid rgba(96, 96, 96, 0.3);
      font-weight: 600;
      color: $green;
      text-align: center;
    }
    &__actions {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      span {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        .material-icons {
          position: static;
        }
      }
    }
  }
}

</style>